<template lang="pug">
div.tw-flex.tw-items-center.tw-gap-2
	span.tw-font-bold {{ departureStation }}
	v-icon(v-if="isRoundTrip" icon="mdi-arrow-left-right" small)
	v-icon(v-else icon="mdi-arrow-right-thin" small)
	span.tw-font-bold {{ arrivalStation }}
	span.tw-font-bold(v-if="isRoundTrip") {{$t('sale.f_r', 'A/R')}}
</template>

<script setup>
import { useBookingStepperStore } from '@/stores/booking-stepper';
import {useI18n} from "vue-i18n";


const i18n = useI18n();
const props = defineProps({
	isRoundTrip: {
		type: Boolean,
		default: false
	},
	departureStation: {
		type: String,
		default: null
	},
	arrivalStation: {
		type: String,
		default: null
	}
});
const stepper = useBookingStepperStore();
</script>